import r from "./_isArrayLike.js";
import o from "./values.js";
import t from "./indexOf.js";
function e(e, i, f, m) {
  return r(e) || (e = o(e)), ("number" != typeof f || m) && (f = 0), t(e, i, f) >= 0;
}
export { e as default };